import { SvgIcon, SvgIconProps } from '@mui/material';

type Props = SvgIconProps;

export const HighestPriority = ({ sx, ...props }: Props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
      sx={{ fill: 'transparent !important', ...sx }}
    >
      <path
        d="M1 6L7 3.5L13 6"
        stroke="#B42318"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 10.5L7 8L13 10.5"
        stroke="#B42318"
        strokeOpacity="0.8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const HighPriority = ({ sx, ...props }: Props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
      sx={{ fill: 'transparent !important', ...sx }}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M1 8.25L7 5.75L13 8.25"
        stroke="#FB6514"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const MediumPriority = ({ sx, ...props }: Props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
      sx={{ fill: 'transparent !important', ...sx }}
    >
      <path d="M1 4.5H13" stroke="#FDB022" strokeWidth="2" strokeLinecap="round" />
      <path d="M1 9.5H13" stroke="#FDB022" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const LowPriority = ({ sx, ...props }: Props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
      sx={{ fill: 'transparent !important', ...sx }}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M13 5.75L7 8.25L1 5.75"
        stroke="#2055FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const LowerPriority = ({ sx, ...props }: Props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      {...props}
      sx={{ fill: 'transparent !important', ...sx }}
    >
      <path
        d="M13 5.75L7 8.25L1 5.75"
        stroke="#2055FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 1.75L7 4.25L1 1.75"
        stroke="#2055FF"
        strokeOpacity="0.8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const LowestPriority = ({ sx, ...props }: Props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
      sx={{ fill: 'transparent !important', ...sx }}
    >
      <path
        d="M13 10.25L7 12.75L1 10.25"
        stroke="#12B76A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 5.75L7 8.25L1 5.75"
        stroke="#12B76A"
        strokeOpacity="0.6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 1.25L7 3.75L1 1.25"
        stroke="#8EAC9E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
